
export default function ServiceAreas() {
  const cities = [
    'Miami', 'Orlando', 'Tampa', 'Jacksonville', 'Fort Lauderdale',
    'St. Petersburg', 'Tallahassee', 'Port St. Lucie', 'Cape Coral', 'Pembroke Pines',
    'Hollywood', 'Miramar', 'Coral Springs', 'Clearwater', 'West Palm Beach',
    'Lakeland', 'Pompano Beach', 'Davie', 'Boca Raton', 'Deltona'
  ];

  return (
    <section id="service-areas" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#1B3A6B] mb-4">
            Serving All of Florida
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Voltis provides expert plumbing, heating, air conditioning, water quality, and electrical services throughout Florida. No matter where you are, we're here to help.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="bg-gradient-to-br from-[#1B3A6B]/5 to-white rounded-2xl p-8 border border-[#1B3A6B]/10 mb-8">
              <h3 className="text-2xl font-bold text-[#1B3A6B] mb-4">
                <i className="ri-map-pin-line text-[#B22234] mr-2"></i>
                Major Service Areas
              </h3>
              <div className="grid grid-cols-2 gap-3">
                {cities.map((city, index) => (
                  <div key={index} className="flex items-center text-sm text-gray-700">
                    <i className="ri-checkbox-circle-fill text-[#B22234] mr-2"></i>
                    <span>{city}</span>
                  </div>
                ))}
              </div>
              <p className="text-sm text-gray-600 mt-6 italic">
                And many more cities across Florida! Call us to confirm service in your area.
              </p>
            </div>

            <div className="bg-[#1B3A6B] rounded-2xl p-8 text-white">
              <h3 className="text-2xl font-bold mb-4">
                Not Sure If We Service Your Area?
              </h3>
              <p className="text-sm text-white/80 mb-6">
                Give us a call and we'll let you know right away. We're constantly expanding our service areas to better serve Florida homeowners.
              </p>
              <a href="tel:+18005551234" className="inline-flex items-center bg-[#B22234] text-white px-6 py-3 rounded-lg text-sm font-semibold hover:bg-[#8B1A29] transition-all whitespace-nowrap cursor-pointer">
                <i className="ri-phone-fill mr-2"></i>
                Call (800) 555-1234
              </a>
            </div>
          </div>

          <div className="relative">
            <div className="rounded-2xl overflow-hidden shadow-2xl">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3592916.1827707!2d-84.3880!3d28.0!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88c1766591562abf%3A0xf72e13d35bc74ed0!2sFlorida!5e0!3m2!1sen!2sus!4v1234567890"
                width="100%"
                height="600"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Voltis Service Areas in Florida"
                className="w-full h-full"
              ></iframe>
            </div>
          </div>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-8">
          <div className="text-center">
            <div className="w-16 h-16 bg-[#1B3A6B]/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-map-pin-2-fill text-3xl text-[#1B3A6B]"></i>
            </div>
            <h4 className="text-xl font-bold text-[#1B3A6B] mb-2">Statewide Coverage</h4>
            <p className="text-sm text-gray-600">
              We serve residential and commercial customers throughout the entire state of Florida.
            </p>
          </div>
          
          <div className="text-center">
            <div className="w-16 h-16 bg-[#B22234]/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-time-fill text-3xl text-[#B22234]"></i>
            </div>
            <h4 className="text-xl font-bold text-[#1B3A6B] mb-2">Fast Response Times</h4>
            <p className="text-sm text-gray-600">
              Our strategically located teams ensure quick response times across all service areas.
            </p>
          </div>
          
          <div className="text-center">
            <div className="w-16 h-16 bg-[#1B3A6B]/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-customer-service-2-fill text-3xl text-[#1B3A6B]"></i>
            </div>
            <h4 className="text-xl font-bold text-[#1B3A6B] mb-2">Local Expertise</h4>
            <p className="text-sm text-gray-600">
              Our technicians understand Florida's unique climate and home service needs.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
